import { type Directive, type DirectiveBinding } from "vue";
import Tooltip, {
  type TooltipDirectiveBinding,
  type TooltipOptions
} from "primevue/tooltip";
import { PresetHelper } from "@/helpers/preset.helper";

const { preset } = new PresetHelper({
  classMap: {
    tai__tooltip_text: {
      layout: ["p-2 rounded-md"],
      typography: ["text-body-sm"],
      color: ["text-white bg-surface-600"]
    }
  },
  preset: {
    text: () => ["tai__tooltip_text"]
  }
});

const attachPreset = (
  binding: TooltipDirectiveBinding
): TooltipDirectiveBinding => {
  const { value } = binding;
  return {
    ...binding,
    value: {
      pt: preset,
      ptOptions: { mergeProps: true },
      value: typeof value === "string" ? value : value?.value,
      ...(binding.value as TooltipOptions)
    }
  };
};

export const taiTooltip: Directive = {
  mounted(el, binding, ...args) {
    if (!Tooltip.mounted) return;
    Tooltip.mounted?.apply(this, [
      el,
      attachPreset(binding) as DirectiveBinding,
      ...args
    ]);
  },
  created(el, binding, ...args) {
    if (!Tooltip.created) return;
    Tooltip.created?.apply(this, [
      el,
      attachPreset(binding) as DirectiveBinding,
      ...args
    ]);
  },
  beforeMount(el, binding, ...args) {
    if (!Tooltip.beforeMount) return;
    Tooltip.beforeMount?.apply(this, [
      el,
      attachPreset(binding) as DirectiveBinding,
      ...args
    ]);
  },
  beforeUpdate(el, binding, ...args) {
    if (!Tooltip.beforeUpdate) return;
    Tooltip.beforeUpdate?.apply(this, [
      el,
      attachPreset(binding) as DirectiveBinding,
      ...args
    ]);
  },
  updated(el, binding, ...args) {
    if (!Tooltip.updated) return;
    Tooltip.updated?.apply(this, [
      el,
      attachPreset(binding) as DirectiveBinding,
      ...args
    ]);
  },
  beforeUnmount(el, binding, ...args) {
    if (!Tooltip.beforeUnmount) return;
    Tooltip.beforeUnmount?.apply(this, [
      el,
      attachPreset(binding) as DirectiveBinding,
      ...args
    ]);
  },
  unmounted(el, binding, ...args) {
    if (!Tooltip.unmounted) return;
    Tooltip.unmounted?.apply(this, [
      el,
      attachPreset(binding) as DirectiveBinding,
      ...args
    ]);
  },
  getSSRProps(binding, ...args) {
    return Tooltip.getSSRProps?.apply(this, [
      attachPreset(binding) as DirectiveBinding,
      ...args
    ]);
  },
  deep: Tooltip.deep
};
